import React, { useEffect } from 'react'
import AppRouter from './router'
import { getProfileService } from './api/auth'
import { actionType } from './reducers/auth'
import useAuth, { AuthProvider } from './context/auth'
import ReactGA from 'react-ga'
import { message } from 'antd'
import * as Sentry from '@sentry/react'

function App() {
  const { state: { user, isAuthenticated }, dispatch } = useAuth()
  useEffect(() => {
    ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`, {
      titleCase: false,
      gaOptions: {
        userId: user?.id
      }
    })
    // eslint-disable-next-line no-undef
    ReactGA.pageview(window.location.pathname + window.location.search)
    let ignore = false

    // eslint-disable-next-line no-undef
    const screenLoader = document.getElementById('screenLoader')

    if (screenLoader && !screenLoader.hasAttribute('hidden')) {
      setTimeout(function () { screenLoader.setAttribute('hidden', 'true') }, 1000)

    }

    async function fetchUserProfile() {
      try {
        const payload = await getProfileService()
        if (!ignore) {
          dispatch({ type: actionType.LOAD_PROFILE, user: payload })
          try {
            if (payload) {
              Sentry.setUser({
                user: JSON.stringify({
                  id: payload?.id,
                  email: payload?.email,
                  displayName: payload?.displayName,
                  grade: payload?.grade,
                  studentId: payload?.studentId,
                  schoolCollabName: payload?.schoolCollabName
                }, null, 2)
              })
            }

          } catch (error) {

          }
        }
      } catch (error) {
        message.error('เกิดข้อผิดพลาดในการเรียกข้อมูล')
      }
    }
    if (!user && isAuthenticated) {
      fetchUserProfile()
    }
    return () => {
      ignore = true
    }
  }, [dispatch, isAuthenticated, user])

  if (!user && isAuthenticated) {
    return null
  }
  return (<AppRouter />)
}

export default () => (
  <AuthProvider>
    <App />
  </AuthProvider>
)
